import { render, staticRenderFns } from "./OrderSlowingDown.vue?vue&type=template&id=dc04468a"
import script from "./OrderSlowingDown.vue?vue&type=script&lang=js"
export * from "./OrderSlowingDown.vue?vue&type=script&lang=js"
import style0 from "./OrderSlowingDown.vue?vue&type=style&index=0&id=dc04468a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports